module.exports = __webpack_public_path__ + "img/exit_to_app-24px.4ba2843a.svg";